import React from 'react';
import './style.scss';
import { FeatureGroup, Polyline } from 'react-leaflet';
import border from '../../data/GeoJSONs/lines.json';
import PopupComponent from '../PopupComponent/PopupComponent';

export default function PolylineComponent(props) {
    const { styles, popupContent, pathType } = props;
    const _dashArray = styles.pathType !== undefined ? styles.pathType : "4 1";
    const _positions = border.lines.find((data) => { if (data.name === props.data) { return data } }).coordinates;

    return (
        <FeatureGroup >
            {popupContent !== undefined ? <PopupComponent popupType="basic" title={popupContent} /> : <div></div>}
            <div className="polyline_component">
                <Polyline dashArray={_dashArray} weight={styles.weight} color={styles.color} positions={_positions} />
            </div>
        </FeatureGroup>
    );
}
